/*
  Opens the desktop header dropdowns on hover.

  Dawn's header panels are <details> elements, so they are click-only. The
  design opens them on hover instead. Touch, keyboard and click keep the native
  behaviour untouched: this only adds mouseenter/mouseleave on top of it, and
  toggling the attribute still fires `toggle`, so HeaderMenu's own onToggle
  (sticky-header offsets, preventHide) runs exactly as it does on a click.

  Both panel shapes are DOM descendants of their <header-menu>, even though the
  wide one is painted full-bleed against .header-wrapper. mouseleave treats an
  element and its descendants as one region, so moving down into the panel does
  not close it, and there is no gap to cross: both panels open flush with the
  bottom of the 50px nav row.
*/
(function () {
  var CLOSE_DELAY = 180;

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desktop = window.matchMedia('(min-width: 990px)');

  function active() {
    return fine.matches && desktop.matches;
  }

  // HeaderMenu.close() also resets aria-expanded, so prefer it over clearing the
  // attribute by hand and leaving the summary claiming it is collapsed.
  function close(headerMenu) {
    if (typeof headerMenu.close === 'function') headerMenu.close();
    else headerMenu.querySelector(':scope > details').removeAttribute('open');
  }

  function open(headerMenu, details) {
    details.setAttribute('open', '');
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function bind(headerMenu) {
    var details = headerMenu.querySelector(':scope > details');
    if (!details || headerMenu.dataset.hoverBound === 'true') return;
    headerMenu.dataset.hoverBound = 'true';

    headerMenu.addEventListener('mouseenter', function () {
      if (!active()) return;
      clearTimeout(headerMenu.hoverTimer);
      document.querySelectorAll('.header__inline-menu header-menu').forEach(function (other) {
        if (other === headerMenu) return;
        clearTimeout(other.hoverTimer);
        close(other);
      });
      open(headerMenu, details);
    });

    // A short grace period before closing. The panels open flush with the nav
    // row, but a fast diagonal move can still clip a corner for a frame, and
    // that would snatch the panel away mid-reach. Re-entering cancels it.
    headerMenu.addEventListener('mouseleave', function () {
      if (!active()) return;
      clearTimeout(headerMenu.hoverTimer);
      headerMenu.hoverTimer = setTimeout(function () {
        close(headerMenu);
      }, CLOSE_DELAY);
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The header is re-rendered when its section is edited in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
